<div class="modal-header">
  <h4 class="modal-title">
    Nueva amonestación
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Cerrar"
    (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">

  @if (loading) {

    <div class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

  } @else {

    <form
      id="formNoticeViolation"
      [formGroup]="formNoticeViolation"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          <div class="col-12 col-md-6 mb-3">
            <label for="streetBuildingId" class="form-label">Calle / edificio</label>
            <ng-select
              inputId="streetBuildingId"
              [items]="streetBuildingService.streetsBuildings"
              bindLabel="name"
              bindValue="streetBuildingId"
              formControlName="streetBuildingId"
              placeholder="Seleccione la calle"
              notFoundText="Sin resultados"
              [ngClass]="{
                'is-invalid': submitted && formControls['streetBuildingId'].errors
              }">
            </ng-select>
            @if (submitted && formControls['streetBuildingId'].errors) {
              <div class="invalid-feedback d-block" role="alert">
                Por favor, seleccione la calle o edificio
              </div>
            }
          </div>

          <div class="col-12 col-md-6 mb-3">
            <label for="houseFlatId" class="form-label">Casa / departamento</label>
            <ng-select
              inputId="houseFlatId"
              [items]="housesFlats"
              bindLabel="number"
              bindValue="houseFlatId"
              formControlName="houseFlatId"
              placeholder="Seleccione la casa"
              notFoundText="Sin resultados"
              [ngClass]="{
                'is-invalid': submitted && formControls['houseFlatId'].errors
              }">
              <ng-template ng-option-tmp let-item="item">
                {{ item.number }}
                @if (item.fullName) {
                  <small class="text-secondary"> &ndash; {{ item.fullName }}</small>
                }
              </ng-template>
            </ng-select>
            @if (submitted && formControls['houseFlatId'].errors) {
              <div class="invalid-feedback d-block" role="alert">
                Por favor, seleccione la casa o departamento
              </div>
            }
          </div>

          <div class="col-12 mb-3 form-group">
            <label for="title" class="form-label">Título</label>
            <input
              type="text"
              id="title"
              class="form-control"
              formControlName="title"
              [maxlength]="titleMaxLength"
              placeholder="Ingrese el título de la amonestación"
              [ngClass]="{
                'is-invalid': submitted && formControls['title'].errors
              }">
            <div class="d-flex justify-content-between align-items-start gap-2">
              <div>
                @if (submitted && formControls['title'].errors) {
                  <div class="invalid-feedback d-block" role="alert">
                    @if (formControls['title'].errors['required']) {
                      Por favor, ingrese el título de la amonestación
                    }
                  </div>
                }
              </div>
              <small class="form-text char-counter flex-shrink-0 mt-1">
                {{ titleLength }}/{{ titleMaxLength }}
              </small>
            </div>
          </div>

          <div class="col-12 mb-3 form-group">
            <label for="description" class="form-label">Descripción</label>
            <textarea
              id="description"
              class="form-control"
              formControlName="description"
              rows="5"
              placeholder="Describa el motivo de la amonestación"
              [ngClass]="{
                'is-invalid': submitted && formControls['description'].errors
              }"></textarea>
            @if (submitted && formControls['description'].errors) {
              <div class="invalid-feedback d-block" role="alert">
                Por favor, ingrese la descripción de la amonestación
              </div>
            }
          </div>

          <div class="col-12 mb-3">
            <div class="files-section">
              <div class="files-title">
                Archivos <span class="files-optional">(opcional)</span>
              </div>
              <div class="d-flex flex-wrap gap-2">
                <button
                  type="button"
                  class="btn btn-outline-primary flex-fill d-flex align-items-center justify-content-center gap-2"
                  (click)="compressFile()">
                  <i class="material-icons" aria-hidden="true">image</i>
                  Agregar fotos
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary flex-fill d-flex align-items-center justify-content-center gap-2"
                  (click)="pdfInput.click()">
                  <i class="material-icons" aria-hidden="true">picture_as_pdf</i>
                  Agregar PDF
                </button>
                <input
                  #pdfInput
                  type="file"
                  id="pdfFiles"
                  class="d-none"
                  accept="application/pdf"
                  multiple
                  (change)="onPdfChange($event)">
              </div>
              <div class="form-text mt-2">
                PDF de máximo {{ noticeViolationService.maxPdfSizeMB }} MB. Las fotos se comprimen automáticamente.
              </div>
            </div>
          </div>

          @if (uploadedImages.length > 0) {

            <div class="col-12 mb-3">
              <div class="files-subtitle">Fotos cargadas</div>
              <div class="d-flex flex-wrap gap-2">
                @for (image of uploadedImages; track $index) {
                  <div class="position-relative">
                    <img
                      [src]="image"
                      [alt]="'Foto ' + ($index + 1) + ' de la amonestación'"
                      class="img-thumbnail thumbnail">
                    <button
                      type="button"
                      class="btn btn-danger btn-sm position-absolute top-0 end-0 m-1 rounded-circle"
                      [attr.aria-label]="'Quitar foto ' + ($index + 1)"
                      (click)="removeImage($index)">
                      <i class="material-icons mt-1" aria-hidden="true">close</i>
                    </button>
                  </div>
                }
              </div>
            </div>

          }

          @if (pdfFiles.length > 0) {

            <div class="col-12 mb-3">
              <div class="files-subtitle">PDF cargados</div>
              <ul class="list-group">
                @for (pdf of pdfFiles; track $index) {
                  <li class="list-group-item d-flex align-items-center gap-2">
                    <i class="material-icons text-danger" aria-hidden="true">picture_as_pdf</i>
                    <span class="flex-grow-1 text-truncate">{{ pdf.name }}</span>
                    <small class="text-secondary flex-shrink-0">
                      {{ (pdf.size / 1024 / 1024).toFixed(2) }} MB
                    </small>
                    <button
                      type="button"
                      class="btn btn-sm btn-light rounded-circle flex-shrink-0"
                      [attr.aria-label]="'Quitar ' + pdf.name"
                      (click)="removePdf($index)">
                      <i class="material-icons mt-1">close</i>
                    </button>
                  </li>
                }
              </ul>
            </div>

          }

        </div>
      </div>
    </form>

  }

</div>
<div class="modal-footer">
  <button
    (click)="activeModal.close()"
    type="button"
    class="btn btn-outline-danger w-100">
    Cancelar
  </button>
  <button
    type="submit"
    form="formNoticeViolation"
    [disabled]="loading"
    class="btn btn-primary w-100">
    Registrar amonestación
  </button>
</div>
